import { Action } from '@ngrx/store';
import { IAlmConfiguration } from '../../../commons';

export enum AlmConfigurationActionTypes {
  LoadAlmConfigurationState = '[AlmConfiguration] Load AlmConfiguration State',
  LoadAlmConfigurationStateSuccess = '[AlmConfiguration] Load AlmConfiguration State Success',
  LoadAlmConfigurationStateFail = '[AlmConfiguration] Load AlmConfiguration State Fail',
  AlmConfigurationScreenErrorReset = '[AlmConfiguration] AlmConfiguration Screen Error Reset'

}

export class LoadAlmConfigurationState implements Action {
  readonly type = AlmConfigurationActionTypes.LoadAlmConfigurationState;
}

export class LoadAlmConfigurationStateSuccess implements Action {
  readonly type = AlmConfigurationActionTypes.LoadAlmConfigurationStateSuccess;
  constructor(public payload: IAlmConfiguration ) {}
}

export class LoadAlmConfigurationStateFail implements Action {
  readonly type = AlmConfigurationActionTypes.LoadAlmConfigurationStateFail;
  constructor(public payload: any) {}
}

export class AlmConfigurationScreenErrorReset implements Action {
  readonly type = AlmConfigurationActionTypes.AlmConfigurationScreenErrorReset;
}

export type AlmConfigurationActions = 
  LoadAlmConfigurationState
  | LoadAlmConfigurationStateSuccess
  | LoadAlmConfigurationStateFail
  | AlmConfigurationScreenErrorReset;